// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__17DCY","content":"PrivacyPolicy_content__1XCvp"};